import echarts from "echarts";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import NativeObject from "../../components/NativeObject/NativeObject";
import Card from "../../components/Cards/Card";

function DetailMobile({ app, config, filter }) {
  const { cards } = config.performanceDetail;
  const { title, tooltip, customRadio, legends, comboCharts } = cards[0];
  const [alignment, setAlignment] = useState("Sell Out");

  useEffect(() => {
    handleChange(filter);
  }, [filter]);

  const handleChange = async (newAlignment) => {
    await app.field("%Selecao").selectMatch(newAlignment);
    setAlignment(newAlignment);
  };

  return (
    <div className="app investments">
      <div className="appContent">
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div
            style={{
              display: "flex",
              width: "100%",
              padding: "0 8px",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h1
              style={{
                marginLeft: "10px",
              }}
            >
              {alignment}
            </h1>
          </div>

          <Card
            header={{
              hardTitle: "Regionais",
              tooltip: tooltip,
            }}
            style={{
              width: "100%",
              height: "500px",
            }}
          >
            <NativeObject app={app} key="qNSBJp" reference={{ id: "qNSBJp" }} />
          </Card>
          <Card
            header={{
              hardTitle: "Grupos Distribuidores",
              tooltip: tooltip,
            }}
            style={{
              width: "100%",
              height: "500px",
            }}
          >
            <NativeObject app={app} key="YDypPM" reference={{ id: "YDypPM" }} />
          </Card>

          <Card
            exportTable
            app={app}
            exportContainer
            exportTableId="VZezD"
            header={{
              hardTitle: "Detalhamento",
              tooltip: "informação",
            }}
            style={{ width: "100%",  height: "500px", alignItems: "center" }}
          >
            <NativeObject
              app={app}
              key="VZezD"
              reference={{ id: "VZezD" }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

DetailMobile.defaultProps = {
  app: null,
  config: {},
  filter: "",
};

DetailMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  filter: PropTypes.string,
};

export default DetailMobile;
